import tw from 'twin.macro';
import styled from 'styled-components';

export const ChaseCardContainer = styled.div`
  ${tw`w-full h-full rounded-xl p-4 pr-2 flex items-center justify-evenly gap-1.5`};
`;

// Images section
export const ChaseCardImages = tw.div`bg-[#7F8283] h-[9.938rem] min-w-[8rem] w-[100%] max-w-[9.188rem] relative rounded-t-[4.25rem] rounded-b-lg`;
export const ChaseCardImage = tw.img`w-full h-full object-cover rounded-t-[4.25rem] rounded-b-lg`;
export const ChaseCardImageAvatar = tw.img`absolute bottom-0 -right-[15%] w-[80%] max-w-[8.313rem] h-[11rem]`;
export const ChaseCardImageCoin = tw.img`w-[0.875rem] h-4`;

// Text section
export const ChaseCardCoin = tw.div`ml-2 flex items-center gap-0.5`;

// content section
export const ChaseCardContent = tw.div`flex flex-col pl-8  justify-start gap-[0.6rem] h-full -mt-1.5`;
export const ChaseCardContentTitle = tw.div`w-full h-[5.75rem] -mt-1`;
export const ChaseCardContentInfo = tw.div`w-full mt-1 flex items-center justify-start gap-2.5 text-base align-middle`;
